import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { CREATE_REPORT } from "../report.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateReportInput } from "../../../__generated__/globalTypes";
import {
  CreateReportMutation,
  CreateReportMutationVariables,
} from "../../../__generated__/CreateReportMutation";

interface IProps {
  defaultValues: DeepPartial<CreateReportInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateReport = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateReportInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateReportMutation,
    CreateReportMutationVariables
  >(CREATE_REPORT, {
    refetchQueries: ["ReportsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createReport?.ok) {
        onCompleted(data.createReport.id);
      } else {
        throw Error(data?.createReport?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
